import React from "react";
import { Label } from "../ui/Label";
import { Input } from "../ui/Input";

interface Props {
  label?: string;
  name?: string;
  placeholder?: string;
  type?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  register?: object; // To pass `react-hook-form`'s register prop
  error?: string; // Error message for the input field
  isIconAllow?: boolean;
  className?: string;
}

const TimeInput: React.FC<Props> = ({
  label,
  name,
  placeholder,
  type,
  value,
  onChange,
  register,
  error,
  isIconAllow = false,
  className,
}) => {
  return (
    <div className="flex flex-col">
      {label && <Label className="font-light mb-2">{label}</Label>}
      <Input
        name={name}
        value={value}
        onChange={onChange}
        {...register}
        placeholder="Select Time"
        type="time"
        className={` ${
          error
            ? "border-red-500 focus-within:ring-red-500"
            : "border-checkboxborder focus-within:ring-0"
        } ${className} `}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default TimeInput;
